function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "96px",
    height: "96px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.865
    },
    fill: "#000000",
    d: "M 73.5,-0.5 C 74.8333,-0.5 76.1667,-0.5 77.5,-0.5C 83.8333,5.16667 89.8333,11.1667 95.5,17.5C 95.5,18.5 95.5,19.5 95.5,20.5C 89.7781,27.3904 83.2781,33.3904 76,38.5C 70.6271,37.3662 69.2938,34.3662 72,29.5C 73.5,28 75,26.5 76.5,25C 55.1667,24.3333 33.8333,24.3333 12.5,25C 12,25.5 11.5,26 11,26.5C 10.6667,36.1667 10.3333,45.8333 10,55.5C 6.90231,59.1074 3.40231,62.1074 -0.5,64.5C -0.5,51.8333 -0.5,39.1667 -0.5,26.5C 1.44,19.3984 6.10666,15.2318 13.5,14C 34.5,13.6667 55.5,13.3333 76.5,13C 74.6667,11.1667 72.8333,9.33333 71,7.5C 70.0182,4.2253 70.8515,1.55863 73.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.865
    },
    fill: "#000000",
    d: "M 95.5,30.5 C 95.5,43.1667 95.5,55.8333 95.5,68.5C 93.56,75.6016 88.8933,79.7682 81.5,81C 60.5,81.3333 39.5,81.6667 18.5,82C 20.3333,83.8333 22.1667,85.6667 24,87.5C 24.9818,90.7747 24.1485,93.4414 21.5,95.5C 20.1667,95.5 18.8333,95.5 17.5,95.5C 11.1667,89.8333 5.16667,83.8333 -0.5,77.5C -0.5,76.5 -0.5,75.5 -0.5,74.5C 5.22193,67.6096 11.7219,61.6096 19,56.5C 24.3729,57.6338 25.7062,60.6338 23,65.5C 21.5,67 20,68.5 18.5,70C 39.8333,70.6667 61.1667,70.6667 82.5,70C 83,69.5 83.5,69 84,68.5C 84.3333,58.8333 84.6667,49.1667 85,39.5C 88.0977,35.8926 91.5977,32.8926 95.5,30.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.8e2df34eefd38e0a6c085e56c92ae630.svg";
export { ForwardRef as ReactComponent };